// Importa le funzioni necessarie dal SDK di Firebase
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Importa il modulo per l'autenticazione

// Configurazione di Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCauPYjRh9bAoninBJc9ISogI26pqRejU4",
  authDomain: "sweettrading-76f4b.firebaseapp.com",
  projectId: "sweettrading-76f4b",
  storageBucket: "sweettrading-76f4b.firebasestorage.app",
  messagingSenderId: "1038143784030",
  appId: "1:1038143784030:web:ae5f65958c74cec77020cf"
};

// Inizializza Firebase
const app = initializeApp(firebaseConfig);

// Ottieni il riferimento all'autenticazione
const auth = getAuth(app);

// Ora puoi usare l'oggetto `auth` per lavorare con Firebase Authentication
export { auth };